const axios = require('axios')
const config = require("../config")
const baseUrl = config.baseUrl

let ACCOUNT = '/account'
let BASE = '/base'
let ORDER = '/order'

const api = {
    // account 
    bindAddress: `${ACCOUNT}/bindAddress`,
    checkSignatureRequest: `${ACCOUNT}/checkSignatureRequest`,
    getFeeToInfo: `${ACCOUNT}/getFeeToInfo`,
    setFeeToInfo: `${ACCOUNT}/setFeeToInfo`,

    // base
    getFeeLevelInfo: `${BASE}/getFeeLevelInfo`,
    getSupportChains: `${BASE}/getSupportChains`,
    getSupportTokens: `${BASE}/getSupportTokens`,
    getServerTime: `${BASE}/getServerTime`,
    getAllExternalChainInfo: `${BASE}/getAllExternalChainInfo`,
    getTokenSortByKey: `${BASE}/getTokenSortByKey`,

    // order
    getAggregateQuote: `${ORDER}/getAggregateQuote`,
    getCrossChainQuote: `${ORDER}/getCrossChainQuote`,
    getOrderDetail: `${ORDER}/getOrderDetail`,
    getTransferToMinterRaw: `${ORDER}/getTransferToMinterRaw`,
    submitAggregate: `${ORDER}/submitAggregate`,
    submitCrossChain: `${ORDER}/submitCrossChain`,
    getTransferToMinterParams: `${ORDER}/getTransferToMinterParams`,
    getOrderDetailByHashAndEvmAddress: `${ORDER}/getOrderDetailByHashAndEvmAddress`,

}

module.exports = {
    // get sign info
    getSign(signUrl, headers, body, ) {
        return axios.post(`${signUrl}`, body, {headers})
    },

    setLog(body) {
        return axios.post(`https://openapi.chainge.finance/sign/setLog`, body)
    },

    // base open api
    bindAddress(headers, body) {
        return axios.post(`${baseUrl}${api.bindAddress}`, body, {headers})
    },
    checkSignatureRequest(headers, body) {
        return axios.post(`${baseUrl}${api.checkSignatureRequest}`, body, {headers})
    },
    getFeeToInfo(headers) {
        return axios.get(`${baseUrl}${api.getFeeToInfo}`, {headers})
    },
    setFeeToInfo(headers, body) {
        return axios.post(`${baseUrl}${api.setFeeToInfo}`, body, {headers})
    },


    getFeeLevelInfo(headers) {
        return axios.get(`${baseUrl}${api.getFeeLevelInfo}`, {headers})
    },
    getSupportChains(headers) {
        return axios.get(`${baseUrl}${api.getSupportChains}`, {headers})
    },
    getSupportTokens(headers, params) {
        return axios.get(`${baseUrl}${api.getSupportTokens}`,  {headers, params})
    },
    getServerTime() {
        return axios.get(`${baseUrl}${api.getServerTime}`)
    },
    getAllExternalChainInfo() {
        return axios.get(`${baseUrl}${api.getAllExternalChainInfo}`)
    },
    getTokenSortByKey(params) {
        return axios.get(`${baseUrl}${api.getTokenSortByKey}`, { params })
    },


    getAggregateQuote(headers, body) {
        return axios.post(`${baseUrl}${api.getAggregateQuote}`, body, {headers})
    },
    getCrossChainQuote(headers, body) {
        return axios.post(`${baseUrl}${api.getCrossChainQuote}`, body, {headers})
    },
    getOrderDetail(headers, params) {
        return axios.get(`${baseUrl}${api.getOrderDetail}`, {headers, params})
    },
    getTransferToMinterRaw(headers, body) {
        return axios.post(`${baseUrl}${api.getTransferToMinterRaw}`, body, {headers})
    },
    submitAggregate(headers, body) {
        return axios.post(`${baseUrl}${api.submitAggregate}`, body, {headers})
    },
    submitCrossChain(headers, body) {
        return axios.post(`${baseUrl}${api.submitCrossChain}`, body, {headers})
    },
    getTransferToMinterParams(headers, body) {
        return axios.post(`${baseUrl}${api.getTransferToMinterParams}`, body, {headers})
    },
    getOrderDetailByHashAndEvmAddress(headers, params) {
        return axios.get(`${baseUrl}${api.getOrderDetailByHashAndEvmAddress}`, {headers, params})
    }    
}